import { ptBR } from "date-fns/locale";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { format, isValid } from "date-fns";
//components
import Select from "../../../components/input/Select";
import Toggle from "../../../components/button/Toggle";
import CalendarInput from "../../../components/input/CalendarInput";
//primereact
import { Button } from "primereact/button";
//services
import { postReportSales } from "../../../services/Report/postReportSales";
//hooks
import { useOptionsSelect } from "../../../hooks/useOptionsSelect";
//context
import { useAppContext } from "../../../context/AppContext";

const FiltersSales = ({
  setTable,
  setNow,
  setLogo,
  setUser,
  setFilters,
  setVisible,
  setCompleteReport,
  completeReport,
  loading,
  setLoading,
}) => {
  const {
    enterprise,
    isLoadingEnterprises,
    blocks,
    isLoadingBlocks,
    selectEnterprise,
    selectBlock,
    selectClient,
    lands,
    isLoadingLands,
    client,
    isLoadingClients,
    team,
    isLoadingTeams,
    selectTeam,
    members,
    loadingMembers,
  } = useOptionsSelect();

  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const options = [
    { label: "Proposta em analise", value: 0 },
    { label: "Proposta recusada", value: 1 },
    { label: "Proposta aprovada", value: 2 },
    { label: "Contrato ativo", value: 3 },
    { label: "Contrato concluido", value: 4 },
    { label: "Contrato cancelado", value: 5 },
    { label: "Contrato Cobrança Extrajudicial", value: 6 },
  ];

  const optionsOrderBy = [
    { label: "Ultimas Vendas", value: "sale" },
    { label: "Q/L", value: "block_land" },
    { label: "Cliente", value: "client" },
  ];

  const defaultValues = {
    orderBy: "sale",
  };

  const dataFormat = (dataString) => {
    const data = new Date(dataString);
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const dia = String(data.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
  };

  const onSubmit = async (data) => {
    // console.log(data);
    let endDate = "";
    let orderBy = "";
    let startDate = "";
    let labelLand = "";
    let labelTeam = "";
    let labelBlock = "";
    let labelMember = "";
    let labelStatus = "";

    if (data.date_start !== undefined && isValid(data.date_start)) {
      startDate = format(data.date_start, "dd/MM/yyyy");
    }

    if (data.date_end !== undefined && isValid(data.date_end)) {
      endDate = format(data.date_end, "dd/MM/yyyy");
    }
    labelBlock =
      data.block_id &&
      blocks.find((item) => item.value === data.block_id)?.label;
    labelLand =
      data.land_id && lands.find((item) => item.value === data.land_id)?.label;
    labelStatus =
      data.status && options.find((item) => item.value === data.status)?.label;
    labelTeam =
      data.team_id && team.find((item) => item.value === data.team_id)?.label;
    labelMember =
      data.member_id &&
      members.find((item) => item.value === data.member_id)?.label;

    if (data.date_start !== undefined) {
      data.date_start = dataFormat(data.date_start);
    }
    if (data.date_end !== undefined) {
      data.date_end = dataFormat(data.date_end);
    }
    data.format = completeReport ? "full" : "default";
    const today = new Date();
    const formattedDate = format(today, "dd 'de' MMMM 'de' yyyy", {
      locale: ptBR,
    });
    setNow(formattedDate);
    delete data.complete;
    setLoading(true);
    if (data.orderBy) {
      orderBy = optionsOrderBy.find(
        (item) => item.value === data.orderBy
      )?.label;
    }

    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    try {
      const response = await postReportSales(data);
      // console.log(response);
      setTable(response);
      const newFilters = [
        { title: "Empreendimento", content: response.enterprise.name },
        { title: "Ordenar por", content: orderBy },
        { title: nomenclature[0].value, content: labelBlock },
        { title: nomenclature[1].value, content: labelLand },
        { title: "Status", content: labelStatus },
        { title: "Imobiliária", content: labelTeam },
        { title: "Corrretor", content: labelMember },
        {
          title: "Período",
          content:
            startDate && endDate !== "" ? `de ${startDate} até ${endDate}` : "",
        },
        {
          title: "Assinado",
          content: data.signature ? "Sim" : "Não",
        },
      ];
      setFilters(newFilters);
      setUser(response.user.name);
      setLogo(response.enterprise.img);
      // console.log(response);
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setLoading(false);
      setVisible(true);
    } catch (e) {
      toast.update(notification, {
        render: "Houve um erro a buscar os dados, tente novamente",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
      setLoading(false);
    }
  };

  const form = useForm({ defaultValues });
  const errors = form.formState.errors;

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="row d-flex mt-4">
        <div className="col-xl-3 col-md-4 mb-3 ">
          <Select
            name="client_id"
            control={form.control}
            label={isLoadingClients ? "Carregando..." : "Cliente"}
            disabled={isLoadingClients}
            options={client}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3">
          <Select
            name="enterprise_id"
            label={isLoadingEnterprises ? "Carregando..." : "Empreendimento *"}
            control={form.control}
            disabled={isLoadingEnterprises}
            isRequired={true}
            onChange={(e) => selectEnterprise(e)}
            options={enterprise}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3">
          <Select
            name="block_id"
            label={isLoadingBlocks ? "Carregando..." : nomenclature[0].value}
            control={form.control}
            errors={errors}
            options={blocks ? blocks : ""}
            disabled={isLoadingBlocks ? true : false || !form.watch("enterprise_id")}
            onChange={(e) => selectBlock(e)}
          />
        </div>
     
        <div className="col-xl-3 col-md-4 mb-3">
          <Select
            name="land_id"
            label={isLoadingLands ? "Carregando..." : nomenclature[1].value}
            control={form.control}
            errors={errors}
            options={lands ? lands : ""}
            disabled={isLoadingLands ? true : false || !form.watch("block_id")}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3">
          <Select
            name="status"
            label="Status"
            control={form.control}
            options={options}
            errors={errors}
          />
        </div>

        <div className="col-xl-3 col-md-4 mb-3">
          
          <Select
            name="team_id"
            label={isLoadingTeams ? "Carregando..." : `Imobiliária`}
            control={form.control}
            errors={errors}
            onChange={(e) => selectTeam(e)}
            disabled={isLoadingTeams ? true : false}
            options={team}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3">
          <Select
            name="member_id"
            label={loadingMembers ? "Carregando..." : "Corretor"}
            control={form.control}
            options={members}
            disabled={loadingMembers ? true : false}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3">
          <CalendarInput
            name="date_start"
            label="Data Início"
            errors={errors}
            control={form.control}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-3">
          <CalendarInput
            name="date_end"
            label="Data Fim"
            errors={errors}
            control={form.control}
          />
        </div>

        {/* Terceira linha com 4 inputs/toggles */}
        <div className="col-xl-3 col-md-4 mb-3">
          <Select
            name="orderBy"
            label="Ordenar por"
            control={form.control}
            options={optionsOrderBy}
            errors={errors}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-2 pt-3">
          <Toggle
            control={form.control}
            name="signature"
            onLabel="Assinado"
            offLabel="Assinado"
            preValue={false}
            getFormErrorMessage={getFormErrorMessage}
          />
        </div>
        <div className="col-xl-3 col-md-4 mb-2 pt-3">
          <Toggle
            name="complete"
            onLabel="Completo"
            offLabel="Completo"
            control={form.control}
            onChange={() => setCompleteReport(!completeReport)}
            preValue={completeReport}
            getFormErrorMessage={getFormErrorMessage}
          />
        </div>
<div className="row">
    <div className="col-xl-12 d-flex justify-content-end mb-2 mt-4">
          <div className="text-center w-25  ">
            <Button
              type="submit"
              icon="fa fa-search"
              aria-label="Search"
              loading={loading}
              className="rounded-3 py-2.5 w-100"
            />
          </div>
        </div>

</div>
      
      </div>
    </form>
  );
};

export default FiltersSales;
